"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGrid = require("@pcty/react-grid");

var _PctyGrid = require("./PctyGrid.common");

var _typeValidation = _interopRequireDefault(require("./typeValidation"));

var PctyExpandableGridRow = function PctyExpandableGridRow(_ref) {
  var id = _ref.id,
      children = _ref.children,
      isExpanded = _ref.isExpanded,
      onClick = _ref.onClick,
      columnSpan = _ref.columnSpan,
      rowClickable = _ref.rowClickable,
      expandableTable = _ref.expandableTable,
      automationId = _ref.automationId,
      __TYPE = _ref.__TYPE,
      other = (0, _objectWithoutProperties2.default)(_ref, ["id", "children", "isExpanded", "onClick", "columnSpan", "rowClickable", "expandableTable", "automationId", "__TYPE"]);
  var otherProps = other;
  var classes = [];
  var toggleClasses = ['pcty-grid-toggle'];
  var toggleProps = {
    'data-automation-id': automationId || null
  };

  if (rowClickable) {
    classes.push('pcty-clickable');
    otherProps.onClick = onClick;
  } else {
    toggleClasses.push('pcty-clickable');
    toggleProps.onClick = onClick;
  }

  if (isExpanded) {
    classes.push('pcty-active');
  }

  if (other.className) {
    classes.push(other.className);
  }

  otherProps.className = classes.join(' ');

  if (expandableTable) {
    var expandableTableChildren = _react.default.Children.toArray(children).filter(function (child) {
      return child.props.__TYPE === 'PctyExpandable';
    }).map(function (x) {
      return /*#__PURE__*/_react.default.cloneElement(x, {
        __expandableTable: true
      });
    });

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("tbody", {
      className: "pcty-grid-expandable-row-wrapper ".concat(isExpanded ? 'pcty-active' : '')
    }, /*#__PURE__*/_react.default.createElement("tr", (0, _extends2.default)({
      className: "pcty-grid-expandable-row",
      key: 'main_' + id
    }, otherProps), /*#__PURE__*/_react.default.createElement("td", (0, _extends2.default)({
      className: toggleClasses.join(' ')
    }, toggleProps)), (0, _PctyGrid.renderChildrenByTypes)(children, [_reactGrid.PctyGridRowCheckboxCell, _reactGrid.PctyGridRowCell]))), /*#__PURE__*/_react.default.createElement("tbody", {
      key: 'expand_' + id,
      className: "pcty-grid-group-details"
    }, expandableTableChildren));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", (0, _extends2.default)({
    className: "pcty-grid-expandable-row",
    key: 'main_' + id
  }, otherProps), /*#__PURE__*/_react.default.createElement("td", (0, _extends2.default)({
    className: toggleClasses.join(' ')
  }, toggleProps)), (0, _PctyGrid.renderChildrenByTypes)(children, [_reactGrid.PctyGridRowCheckboxCell, _reactGrid.PctyGridRowCell])), /*#__PURE__*/_react.default.createElement("tr", {
    key: 'expand_' + id,
    className: "pcty-grid-details"
  }, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: columnSpan
  }, (0, _PctyGrid.renderChildrenByTypes)(children, [_reactGrid.PctyExpandable]))));
};

PctyExpandableGridRow.propTypes = {
  /** Unique key */
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,

  /** If true, applies expanded styling to the item */
  isExpanded: _propTypes.default.bool,

  /** A handler function for the toggle click event */
  onClick: _propTypes.default.func,

  /** Number of columns to span (not including the toggle) */
  columnSpan: _propTypes.default.number,

  /** Is the row clickable */
  rowClickable: _propTypes.default.bool,

  /** Removes padding from accordion content and maintains table flow */
  expandableTable: _propTypes.default.bool,

  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes.default.string,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyExpandableGridRow');
  }
  /** INCLUDE OTHER */

};
PctyExpandableGridRow.defaultProps = {
  id: '',
  isExpanded: false,
  onClick: function onClick() {},
  columnSpan: 1,
  rowClickable: false,
  expandableTable: false,
  __TYPE: 'PctyExpandableGridRow'
};
var _default = PctyExpandableGridRow;
exports.default = _default;